import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/icons/workflow/close.svg'
import _imports_1 from '../../../public/icons/help.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-57b4f132"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = {
  key: 1,
  class: "header-v2"
}
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "body content" }
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = { class: "panelButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "rightPanel",
            style: _normalizeStyle({ height: _ctx.IsEmbedded ? 'calc(100vh - 40px)' : 'calc(100vh - 47px)' })
          }, [
            (!_ctx.fixOverlappingHeaderCloseButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _createTextVNode(" default header ")
                  ], true),
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "theme-svg",
                    id: "close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }),
                  (_ctx.Can_OpenHelp)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_1,
                        class: _normalizeClass(["theme-svg", {md:_ctx.size==='md'}]),
                        id: "help",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.OpenHelp && _ctx.OpenHelp(...args)))
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "header", {}, () => [
                      _createTextVNode(" default header ")
                    ], true)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      width: "24",
                      src: _imports_0,
                      class: "theme-svg",
                      id: "close-v2",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                    }),
                    (_ctx.Can_OpenHelp)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          width: "24",
                          src: _imports_1,
                          class: _normalizeClass(["theme-svg", {md:_ctx.size==='md'}]),
                          id: "help-v2",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OpenHelp && _ctx.OpenHelp(...args)))
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ])
                ])),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _createTextVNode(" default body ")
              ], true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CommonButton, {
                    type: _ctx.ButtonType.Primary,
                    text: _ctx.Localizer.Localize('Ok_PascalCase'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
                  }, null, 8, ["type", "text"])
                ])
              ], true)
            ]),
            _renderSlot(_ctx.$slots, "modal", {}, undefined, true)
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}